import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { ISpeech } from 'src/interfaces/speech.interface';
import { addSpeech } from 'src/store/actions/speech.action';
import Swal from 'sweetalert2';
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'add-speech-form',
  templateUrl: './add-speech-form.component.html',
  styleUrls: ['./add-speech-form.component.css'],
})
export class AddSpeechFormComponent implements OnInit {
  title: string = '';
  author: string = '';
  dateCreated: string = '';
  content: string = '';

  authors$: Array<string> = [];

  constructor(private store: Store<any>) {
    this.store.select('speech').subscribe((q) => {
      this.authors$ = q.authors;
    });
  }

  submit() {
    this.store.dispatch(
      addSpeech({
        data: {
          title: this.title,
          content: this.content,
          author: this.author,
          date: this.dateCreated,
          id: uuidv4(),
        } as ISpeech,
      })
    );
    this.title = '';
    this.author = '';
    this.dateCreated = '';
    this.content = '';
  }

  onAddSpeech(event: Event) {
    event.preventDefault();

    if (!this.title) {
      Swal.fire('Please enter title', '', 'error');
    } else if (!this.author) {
      Swal.fire('Please select author', '', 'error');
    } else if (!this.content) {
      Swal.fire('Please enter speech content', '', 'error');
    } else if (!this.dateCreated) {
      Swal.fire('Please enter date', '', 'error');
    } else {
      this.submit();
    }
  }

  ngOnInit(): void {}
}
